export default {
  cat_all: 'All',
  cat_beef: 'Beef',
  cat_pork: 'Pork',
  cat_chicken: 'Poultry',
  cat_goat: 'Goat',
  cat_seafood: 'Seafood',

  nav_home: 'Home',
  nav_catalog: 'Catalog',
  nav_about: 'About',
  nav_testimonials: 'Reviews',
  nav_contact: 'Contact',
  nav_visit: 'Visit Us',

  hero_badge: 'Premium Meat Market in Manhattan',
  hero_title_line1: 'Authentic Latin Cuts',
  hero_title_line2: 'in the Heart of Manhattan',
  hero_subtitle:
    'The freshest cuts for Caribbean and Latin cooking. Tripe, goat, pork rinds, pork shoulder and everything your Dominican and Puerto Rican table needs.',
  hero_cta_explore: 'View Cuts',
  hero_cta_story: 'About Us',
  hero_stat_suppliers: 'Premium Suppliers',
  hero_stat_cuts: 'Different Cuts',
  hero_stat_clients: 'Happy Clients',

  catalog_badge: 'Our Catalog',
  catalog_title: 'Fresh Cuts Daily',
  catalog_desc:
    'Fresh meats selected for Latin cuisine. From tripe to goat, pork shoulder and fresh fish.',
  catalog_coming_soon: 'Coming Soon',
  catalog_empty: 'No products in this category at the moment.',
  catalog_price_disclaimer: '* All prices shown are for reference only and are subject to market fluctuation. Please check current prices directly at the store or via WhatsApp.',

  about_badge: 'About Us',
  about_title: 'Authentic Flavor,',
  about_title_highlight: 'Real Cuts',
  about_desc:
    'At L&J PREMIUM MEATS LLC we bring the flavors of home to your table in Manhattan. We are a family-run Latin butcher shop that understands what your kitchen needs: tripe for soup, pork shoulder for Christmas, goat for the party, and pork rinds for Sunday.',
  about_stat_suppliers: 'Certified Suppliers',
  about_stat_farms: 'Local Suppliers',
  about_stat_accepted: 'Fresh Meats',

  feat_sustainability: 'Guaranteed Freshness',
  feat_sustainability_desc:
    'Fresh meats every day. We receive new product each morning for your family.',
  feat_quality: 'Always Quality',
  feat_quality_desc:
    'We select each cut by hand. Only the best product reaches your table.',
  feat_fresh: 'Daily Cuts',
  feat_fresh_desc:
    'Fresh ground daily. Marinated pork shoulder, chops ready for the grill.',
  feat_origin: 'Home Flavor',
  feat_origin_desc:
    'The cuts we know from Dominican, Puerto Rican and Latin cooking.',

  cert_title: 'Certified',
  cert_desc: 'USDA Inspected. Authorized and regulated butcher shop.',

  testimonials_badge: 'Reviews',
  testimonials_title: 'What Our People Say',
  testimonials_subtitle:
    'The trust of our community is what drives us every day. Latin clients who return for the quality.',

  trust_usda: 'USDA Inspected',
  trust_eco: 'Daily Cuts',
  trust_delivery: 'Local Delivery',
  trust_antibiotics: 'Always Fresh',

  cta_title: 'Visit Us Today',
  cta_title_highlight: 'in Manhattan',
  cta_desc:
    'Come visit our shop. Javier, Luisa and Henry are waiting for you with the freshest cuts. Bring the flavor of home to your table!',
  cta_map: 'View Location',
  cta_call: 'Call Now',

  info_hours: 'Hours',
  info_hours_week: 'Mon - Sat: 8am - 7pm',
  info_hours_sun: 'Sun: 9am - 3pm',
  info_address: 'Address',
  info_phone: 'Phone',
  info_whatsapp: 'WhatsApp / Text',

  footer_desc:
    'Authentic Latin cuts in Manhattan. Freshness, quality and the flavor of home.',
  footer_nav: 'Navigation',
  footer_popular: 'Popular Cuts',
  footer_contact: 'Contact',

  footer_privacy: 'Privacy',
  cta_whatsapp: 'Message on WhatsApp',
  footer_copyright: '© 2026 L\u0026J Premium Meats. All rights reserved.',

  badge_best_seller: 'Best Seller',
  badge_popular: 'Popular',
  badge_specialty: 'Specialty',
  badge_fresh: 'Daily Fresh',

  // Product names
  prod_costilla_res: 'Beef Ribs',
  prod_rabo: 'Oxtail',
  prod_costilla_cerdo: 'Pork Ribs',
  prod_pernil: 'Pork Shoulder',
  prod_pata_vaca: 'Beef Shank',
  prod_bistec: 'Top Round Steak',
  prod_carne_molida: 'Ground Beef',
  prod_chuleta: 'Pork Chops',
  prod_chivo: 'Goat',
  prod_bola_res: 'Beef Round',
  prod_mondongo: 'Beef Tripe',
  prod_orejita: 'Pork Ears',
  prod_higado: 'Beef Liver',
  prod_masita: 'Pork Chunks',
  prod_chicharron: 'Pork Rinds',
  prod_churrasco: 'Skirt Steak',
  prod_pechuga: 'Chicken Breast',
  prod_ala_pollo: 'Chicken Wings',
  prod_gallina: 'Hen',
  prod_muslo: 'Chicken Leg Quarters',
  prod_pollo_entero: 'Whole Chicken',
  prod_molleja: 'Chicken Gizzard',
  prod_ala_pavo: 'Turkey Wings',
  prod_basa: 'Basa Fillet',
  prod_pescado: 'Whole Fish',

  // Product descriptions
  desc_costilla_res:
    'Fresh bone-in beef ribs, perfect for stews, soups and roasts.',
  desc_rabo:
    'Oxtail ideal for sancocho, braised oxtail and traditional soups.',
  desc_costilla_cerdo:
    'Tender pork ribs for stewing or grilling on the barbecue.',
  desc_pernil:
    'Whole pork shoulder, perfect for Christmas and family gatherings.',
  desc_pata_vaca:
    'Bone-in beef shank, ideal for soups and nourishing broths.',
  desc_bistec:
    'Thinly sliced top round steak, ideal for steak and onions and stir-fries.',
  desc_carne_molida:
    'Fresh daily ground beef, perfect for meatballs, empanadas and pastelón.',
  desc_chuleta:
    'Bone-in pork chops, ready for the grill or stewed.',
  desc_chivo:
    'Fresh goat, the essential cut for the Latin party and celebration.',
  desc_bola_res:
    'Beef round for stewing, ideal for shredded beef and stews.',
  desc_mondongo:
    'Clean and fresh beef tripe, the star ingredient of sancocho.',
  desc_orejita:
    'Fresh pork ears for stewing, ideal for tacos and soups.',
  desc_higado:
    'Fresh beef liver, rich in iron and perfect for stewing.',
  desc_masita:
    'Pork chunks for frying, the crispy touch of Caribbean cooking.',
  desc_chicharron:
    'Fresh and crispy pork rinds, straight from the fryer to your table.',
  desc_churrasco:
    'Marinated skirt steak, ideal for the Dominican grill.',
  desc_pechuga:
    'Fresh boneless chicken breast, ready to fillet or stew.',
  desc_ala_pollo:
    'Fresh chicken wings, perfect for frying or baking with seasoning.',
  desc_gallina:
    'Whole hen, ideal for hen sancocho and chicken soups.',
  desc_muslo:
    'Bone-in chicken leg quarters, juicy and perfect for stews and rice.',
  desc_pollo_entero:
    'Fresh whole chicken, ready to roast or stew with your favorite recipe.',
  desc_molleja:
    'Fresh chicken gizzard, delicious fried or stewed with lemon.',
  desc_ala_pavo:
    'Large and juicy turkey wings, perfect for baking or stewing.',
  desc_basa:
    'Fresh basa fillet, soft and perfect for frying or baking.',
  desc_pescado:
    'Fresh whole fish, ready to fry with lemon and tostones.',

  testimonial_1_text:
    'I always buy my Christmas pork shoulder here. Fresh, well cut and with that home flavor you can\u0027t find at any other butcher in Manhattan. Recommended!',
  testimonial_2_text:
    'As a Dominican chef, I need fresh tripe and real goat. They always have what I need for my restaurant. Unmatched quality in the city.',
  testimonial_3_text:
    'The ground beef is always fresh, never frozen. I make my meatballs and empanadas and the whole family notices the difference. The family treatment is the best.',
  testimonial_4_text:
    'For my Dominican barbecues, the skirt steak and chops from here are the best. Javier always cuts exactly what I ask for. Family service.',
  testimonial_5_text:
    'Fresh goat is hard to find in Manhattan, but they always have it. For my husband\u0027s birthday, the stewed goat was spectacular.',
  testimonial_6_text:
    'The pork rinds are crispy, the fish is fresh and the pork shoulder... don\u0027t even get me started! Like being at the butcher shop in Santo Domingo. Javier and Henry know their craft.',
};